import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import T from 'i18n-react';
import './Dashboard.css';
import TaxYearSection from '../../../../../components/Workflow/TaxYearSection/TaxYearSection';
import { getIcon } from '../../../../../utils/IconUtil';
import MessageLink from '../../../../Controls/messageLink';

const FiledReturnSection = (props) => {
    const currentTaxYear = useSelector(state => state.layout?.currentTaxYear)
    const lang = useSelector(state => state.layout?.lang)
    var messageLink = <MessageLink linkKey='WorkflowPanel.download.message-link' />;
    return (
        <div className='wf-filed-return-section-wrapper'>
            <img src={getIcon('complete-active')} alt="dot" />
            <div className='wf-filed-return-section'>
                <div className='wf-filed-return-section-title'>{T.translate('WorkflowLinear.workflowStepTitle_ReturnFiled')}</div>
                <div className='wf-filed-return-section-subtitle'>{T.translate('WorkflowLinear.worflowStepSubTitle_ReturnFiled', { TaxYear : props.taxState.taxYear , MessageLink: messageLink })}</div>
                <TaxYearSection
                    securityComplete={true}
                    taxState={props.taxState} 
                    lang={lang}
                    currentYear={currentTaxYear}
                    onWorkflowButtonAction={props.handleWorkflowButton}
                    paymentInfo={null}
                    section='filed'
                />
            </div>
        </div>
    )
}

export default FiledReturnSection;